import React from 'react';
import illustration from 'assets/images/invitations/bleed_img.png';
import styles from './styles.module.less';

const BleedModal = () => (
  <div className={styles['content-wrapper']}>
    <div className={styles.column}>
      <div className={styles['img-wrapper']}>
        <img src={illustration} className={styles.img} alt="" />
        <div className={styles.img__legend}>Safety Line</div>
        <div className={styles.img__legend}>Trim Area</div>
      </div>
    </div>
    <div className={styles.column}>
      <h1 className={styles.title}>All About the Safety Line and Trim Area</h1>
      <p className={styles.text}>
        Our designs are printed on large sheets of card stock, then trimmed down to size. Follow the
        guidelines below to ensure all important content on your cards is included during the
        printing process.
      </p>
      <h2 className={styles['sub-title']}>Safety Line</h2>
      <p className={styles.text}>
        The dotted line you see when customizing your design is the safety line, not the edge of
        your card. All content inside this line is guaranteed to be included when printed.
      </p>
      <h2 className={styles['sub-title']}>Trim Area</h2>
      <p className={styles.text}>
        Text or images in this area may be trimmed during the printing process.
      </p>
      <p className={styles.text}>
        To avoid printing unwanted white space around your card, make sure images extend fully to
        the edge of your design. Remember to keep important parts of your images (like your faces)
        inside the safety line.
      </p>
    </div>
  </div>
);

export default BleedModal;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/BleedModal/BleedModal.jsx